import {
  BankAccountInfiniteSelectField,
  CompaniesInfiniteSelectField,
  FloatingFormItem,
  InputDate,
  InputDecimal,
} from '@/components/_common';
import StatusTag from '@/components/_common/StatusTag';
import { BilletsStatusType } from '@/core/domain/financial/Boletos/Boletos.types';
import {
  BilletsStatusColor,
  ListBillets,
} from '@/core/domain/financial/Boletos/Boletos.types';
import { useWindowSize } from '@/hooks';
import {
  Button,
  Col,
  Form,
  FormInstance,
  Input,
  Row,
  Space,
  Typography,
} from 'antd';
import React from 'react';
import { CheckSquare, XSquare } from 'react-feather';

interface Props {
  form: FormInstance;
  selectedBankSlip?: ListBillets;
}

const BankSlipViewModalForm: React.FC<Props> = ({ form, selectedBankSlip }) => {
  const { isMobile } = useWindowSize();

  return (
    <Form form={form}>
      <Row gutter={[12, 12]}>
        <Col xs={24} sm={12}>
          <Typography.Title level={4}>
            Situação:{' '}
            <StatusTag
              style={{ fontSize: 20, padding: 10 }}
              label={
                selectedBankSlip
                  ? BilletsStatusType[selectedBankSlip?.status]
                  : ''
              }
              color={
                selectedBankSlip
                  ? BilletsStatusColor[selectedBankSlip?.status]
                  : 'red'
              }
            />
          </Typography.Title>
        </Col>

        <Col xs={24} sm={12}>
          <Space
            style={{
              width: '100%',
              height: '100%',
              justifyContent: isMobile ? 'center' : 'end',
            }}
            align="center"
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {selectedBankSlip?.remittanceEmitted ? (
                <CheckSquare color="green" />
              ) : (
                <XSquare color="red" />
              )}
            </div>

            <Typography.Text>
              {selectedBankSlip?.remittanceEmitted
                ? 'Remessa Gerada'
                : 'Remessa não Gerada'}
            </Typography.Text>
          </Space>
        </Col>

        <Col span={24} md={24} lg={8}>
          <FloatingFormItem label="Empresa" name="companyId">
            <CompaniesInfiniteSelectField disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={8}>
          <FloatingFormItem name="documentNumber" label="Nº Documento">
            <Input disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={8}>
          <FloatingFormItem name="ourNumber" label="Nosso Número">
            <Input disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={6} lg={8}>
          <FloatingFormItem name="createdAt" label="Data Emissão">
            <InputDate disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={6} lg={8}>
          <FloatingFormItem name="dueDate" label="Data Vencimento">
            <InputDate disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={6} lg={8}>
          <FloatingFormItem name="liquidationDate" label="Data Liquidação">
            <InputDate disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={6} lg={8}>
          <FloatingFormItem name="cancelDate" label="Data Cancelamento">
            <InputDate disabled />
          </FloatingFormItem>
        </Col>

        {!!selectedBankSlip?.writeOffProtocol && (
          <Col span={24} md={6} lg={8}>
            <FloatingFormItem
              name="writeOffProtocol"
              label="Protocolo da baixa"
            >
              <Input disabled />
            </FloatingFormItem>
          </Col>
        )}

        <Col span={24} md={6} lg={8}>
          <FloatingFormItem name="dischargeDate" label="Data Baixa">
            <InputDate disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={16}>
          <FloatingFormItem name="bankAccountId" label="Conta Bancária">
            <BankAccountInfiniteSelectField
              disabled
              queryFilter={{ active: true }}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={8}>
          <FloatingFormItem name="titleValue" label="Valor">
            <InputDecimal disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem name="digitableLine" label="Linha Digitável">
            <Input disabled />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem name="barCode" label="Código de Barras">
            <Input disabled />
          </FloatingFormItem>
        </Col>

        {!!selectedBankSlip?.accountReceivableId &&
          !!selectedBankSlip.installmentReceivableId && (
            <Col span={24} style={{ display: 'flex', justifyContent: 'end' }}>
              <Button
                type="primary"
                onClick={() =>
                  window.open(
                    `/app/financial/billToReceiver/releaseBillToReceiver/${selectedBankSlip?.accountReceivableId}/installment/${selectedBankSlip?.installmentReceivableId}/general`,
                    '_blank',
                  )
                }
              >
                Ir até a parcela
              </Button>
            </Col>
          )}
      </Row>
    </Form>
  );
};

export default BankSlipViewModalForm;
